import * as userService from 'services/user';
import { SectionTitle, useCompanyFormState } from '../common';
import { CompanyCategoriesField, CompanyAssociatedPersonField } from '../fields';
import ContactsIcon from '@material-ui/icons/Contacts';
import { blue, green } from '@material-ui/core/colors';
import { Divider, Grid, IconButton, Tooltip } from '@material-ui/core';
import { useFormContext, useWatch } from 'react-hook-form';
import { CompanyServiceField } from '../fields';
import { useRecentGetter } from '@lib/common';
import { useSubject } from '@lib/common/hooks/use-subject';
import { useSubscription } from '@lib/common/hooks/use-subscription';
import { useEffect, useState } from 'react';
import { debounceTime, filter, pairwise, map, startWith } from 'rxjs/operators';
import { useInsightActions } from '../service-insights';
import { CompanyMasters } from '@api/masters';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockClosedIcon from '@material-ui/icons/Lock';
import Fab from '@material-ui/core/Fab';
import styled from 'styled-components';
import { VerifiedDetails } from './section-utils';
import { ExpandLessRounded, ExpandMoreRounded } from '@material-ui/icons';

export const SectionAssociatedPerson = () => {
  const { control } = useFormContext();
  const form = useFormContext();
  const { edit, company } = useCompanyFormState();
  const { user } = userService.useUser();
  const [isLock, setLock] = useState<Boolean>(
    (company &&
      company.verified_sections &&
      company.verified_sections.associated_person_section &&
      company.verified_sections.associated_person_section.verified) ||
      edit,
  );
  const watchOnVerifiedSections = form.watch('verified_sections');
  const verifiedBy =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.associated_person_section &&
    watchOnVerifiedSections.associated_person_section.verified_by;
  const verifiedAt =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.associated_person_section &&
    watchOnVerifiedSections.associated_person_section.verified_at + ' IST';

  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const handleToggleExpand = () => {
    setIsExpanded(prev => !prev);
  };
  return (
    <>
      <Grid
        container
        spacing={2}
        justify="space-between"
        alignItems="center"
        onClick={handleToggleExpand}
        style={{
          cursor: 'pointer',
          userSelect: 'none',
          transition: 'background 0.2s ease',
        }}
        onMouseEnter={e => (e.currentTarget.style.background = '#f5f5f5')}
        onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}>
        <Grid item>
          <SectionTitle
            id="company-associated-persons"
            title="Company Associated Person"
            subTitle="Information about Associated Person"
            icon={sectionIcon}
          />
        </Grid>
        <Grid item style={{ paddingBottom: '10px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <Tooltip
            title={
              isLock ? (
                <>
                  {`Verified by ${verifiedBy}`}
                  <br />
                  {`Verified at ${verifiedAt}`}
                </>
              ) : (
                'Click to Lock the Section'
              )
            }>
            {isLock ? (
              <StyledFab
                color="primary"
                style={{ backgroundColor: 'green' }}
                aria-label="add"
                size="small"
                onClick={e => {
                  e.stopPropagation();
                  setLock(false);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    associated_person_section: {
                      verified: false,
                      verified_by: null,
                      verified_at: null,
                      isLockApplied: false,
                    },
                  });
                }}>
                <LockClosedIcon />
              </StyledFab>
            ) : (
              <StyledFab
                color="primary"
                aria-label="add"
                style={{ backgroundColor: 'red' }}
                size="small"
                onClick={e => {
                  e.stopPropagation();
                  setLock(true);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    associated_person_section: {
                      verified: true,
                      verified_by: user.vtr_id,
                      verified_at: new Date().toLocaleString('en-US', { timeZone: 'IST' }),
                      isLockApplied: true,
                    },
                  });
                  // company.verified_sections.associated_person_section.verified_by = user.vtr_id;
                  // company.verified_sections.associated_person_section.verified = true;
                }}>
                <LockOpenIcon />
              </StyledFab>
            )}
          </Tooltip>
          {isLock && <VerifiedDetails verifiedBy={verifiedBy} verifiedAt={verifiedAt} />}
          {/* Expand / Collapse Button */}
          <Tooltip title={isExpanded ? 'Collapse section' : 'Expand section'}>
            <IconButton
              size="small"
              onClick={e => {
                e.stopPropagation();
                handleToggleExpand();
              }}>
              {isExpanded ? (
                <ExpandLessRounded color="primary" fontSize="large" />
              ) : (
                <ExpandMoreRounded color="primary" fontSize="large" />
              )}
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>

      <Divider />
      <br />
      <Grid container spacing={1} style={{ display: isExpanded ? 'flex' : 'none' }}>
        <Grid item xs={12}>
          <CompanyAssociatedPersonField
            control={control}
            name="associated_person"
            isLock={isLock}
          />
        </Grid>
      </Grid>
    </>
  );
};

const sectionIcon = <ContactsIcon fontSize="large" style={{ color: blue[600] }} />;

const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;
